<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="渠道商CODE：" prop="partner_code">
                    <el-input v-model.trim="form.partner_code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="用户账号：" prop="account">
                    <el-input v-model.trim="form.account" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="用户名：" prop="name">
                    <el-input v-model.trim="form.name" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item label="电话：" prop="mobile">
                    <el-input v-model.trim="form.mobile" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="text-align: right;margin-bottom: 8px;">
            <el-button type="primary" size="small" @click="add">新建</el-button>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="渠道商CODE">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="用户账号">
                <template v-slot="scope">
                    <span>{{ scope.row.account }}</span>
                </template>
            </el-table-column>
            <el-table-column label="用户名">
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="电话">
                <template v-slot="scope">
                    <span>{{ scope.row.mobile }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template v-slot="scope">
                    <span style="color:#36C626" v-if="scope.row.status == 1">启用</span>
                    <span style="color:#FF1A2E" v-else>禁用</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间">
                <template v-slot="scope">
                    <span>{{
                        dayjs
                            .unix(scope.row.create_time)
                            .format('YYYY-MM-DD HH:mm:ss')
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="修改时间">
                <template v-slot="scope">
                    <span>{{
                        dayjs
                            .unix(scope.row.update_time)
                            .format('YYYY-MM-DD HH:mm:ss')
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="340px">
                <template v-slot="scope">
                    <el-button type="info" size="mini" class="btnClass" @click="edit(scope.row)">编辑</el-button>
                    <el-button type="danger" size="mini" @click="deleteUser(scope.row)">删除</el-button>
                    <router-link style="margin-left:10px;margin-right: 10px;"
                        :to="'/salespartner/permission/user/assignRole/' + scope.row.id">
                        <el-button type="success" size="mini">分配角色</el-button>
                    </router-link>
                    <el-button type="primary" size="mini" @click="resetPassword(scope.row)">重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
        <el-dialog v-model="addUserVisible" :title="isEdit ? '编辑用户' : '新增用户'" width="570px">
            <el-form ref="addFormRef" :model="addForm" size="small" label-width="110px" :rules="addRules">
                <el-form-item label="渠道商：" prop="partner_code" v-if="!isEdit">
                    <el-select v-model="addForm.partner_code" placeholder="请选择" :disabled="isEdit">
                        <el-option v-for="item in partnerList" :label="item.partner_name" :value="item.code"
                            :key="item.code" />
                    </el-select>
                </el-form-item>
                <el-form-item label="用户账号：" prop="account" v-if="!isEdit">
                    <el-input v-model="addForm.account" autocomplete="off" :disabled="isEdit" />
                </el-form-item>
                <el-form-item label="用户名：" prop="name">
                    <el-input v-model="addForm.name" autocomplete="off" />
                </el-form-item>
                <el-form-item label="密码：" prop="password" v-if="!isEdit">
                    <el-input v-model="addForm.password" autocomplete="off" />
                </el-form-item>
                <el-form-item label="电话：" prop="mobile">
                    <el-input v-model="addForm.mobile" autocomplete="off" />
                </el-form-item>
                <el-form-item label="超级管理员：" prop="is_super">
                    <el-select v-model="addForm.is_super" placeholder="请选择">
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                    </el-select>
                </el-form-item>
                <el-form-item label="状态：" prop="status">
                    <el-select v-model="addForm.status" placeholder="请选择">
                        <el-option label="启用" :value="1" />
                        <el-option label="禁用" :value="2" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="addUserVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="updateUser(addFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
        <el-dialog v-model="resetPasswordVisible" title="重置密码" width="400px">
            <el-form ref="resetPasswordFormRef" :model="resetPasswordForm" size="small" label-width="70px"
                :rules="resetPasswordRules">
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="resetPasswordForm.password" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="dialog-footer">
                    <el-button size="small" @click="resetPasswordVisible = false">取消</el-button>
                    <el-button type="primary" size="small" @click="updatePassword(resetPasswordFormRef)">
                        确认
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import util from '../../../../util/util'
import api from '../../../../axios/api'
import dayjs from 'dayjs'
import md5 from 'js-md5'

export default {
    setup() {
        const form = reactive({
            partner_code: '',
            account: '',
            name: '',
            mobile: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])
        const addUserVisible = ref(false)
        const addForm = reactive({
            partner_code: '',
            account: '',
            name: '',
            mobile: '',
            password: '',
            status: 1,
            is_super: 0
        })
        const addFormRef = ref()
        const addRules = reactive({
            partner_code: [
                { required: true, message: '请选择渠道商', trigger: 'blur' }
            ],
            account: [
                { required: true, message: '请输入用户账号', trigger: 'blur' }
            ],
            name: [
                { required: true, message: '请输入用户名', trigger: 'blur' }
            ],
            password: [
                {
                    required: true, validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("请输入密码"))
                        }
                        const reg =
                            /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,24}$/
                        if (!reg.test(value)) {
                            callback(
                                new Error(
                                    "密码须由数字、小写字母、大写字母、特殊字符至少三种构成,长度至少为6位!"
                                )
                            )
                        } else {
                            callback()
                        }
                    }, trigger: 'blur'
                }
            ],
            mobile: [
                { required: true, message: '请输入手机号', trigger: 'blur' }
            ],
            status: [
                { required: true, message: '请选择状态', trigger: 'blur' }
            ],
            is_super: [
                { required: true, message: '请选择是否是超级管理员', trigger: 'blur' }
            ]
        })
        const resetPasswordVisible = ref(false)
        const resetPasswordForm = reactive({
            password: '',
        })
        const resetPasswordFormRef = ref()
        const resetPasswordRules = reactive({
            password: [
                {
                    required: true, validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("请输入密码"))
                        }
                        const reg =
                            /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,24}$/
                        if (!reg.test(value)) {
                            callback(
                                new Error(
                                    "密码须由数字、小写字母、大写字母、特殊字符至少三种构成,长度至少为6位!"
                                )
                            )
                        } else {
                            callback()
                        }
                    }, trigger: 'blur'
                }
            ],
        })
        const partnerList = ref([])
        const isEdit = ref(false)

        const getSalesPartnerList = async () => {
            const res = await api.SalesPartnerList({ page: 1, limit: 1000 })
            if (res.data.code === 200) {
                const { data } = res.data.data
                partnerList.value = data
            }
        }

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerPermissionUserList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
                pagination.page = page_info.current_page
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            addUserVisible.value = true
            isEdit.value = false
            addForm.partner_code = ''
            addForm.account = ''
            addForm.name = ''
            addForm.mobile = ''
            addForm.status = 1
            addForm.is_super = 0
            addForm.password = ''
            addFormRef.value?.clearValidate()
        }

        const edit = (row) => {
            addUserVisible.value = true
            addForm.name = row.name
            addForm.mobile = row.mobile
            addForm.status = row.status
            addForm.is_super = row.is_super || 0
            addForm.id = row.id
            isEdit.value = true
            addFormRef.value?.clearValidate()
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        const updateUser = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const apiMethod = isEdit.value ? api.SalesPartnerPermissionUserUpdate : api.SalesPartnerPermissionUserCreate
                        let params = {}
                        if (isEdit.value) {
                            params.name = addForm.name
                            params.mobile = addForm.mobile
                            params.status = addForm.status
                            params.is_super = addForm.is_super
                            params.id = addForm.id
                        } else {
                            params = {
                                ...toRaw(addForm),
                                password: md5(addForm.password)
                            }
                        }
                        const res = await apiMethod(params)
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            addUserVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const deleteUser = (row) => {
            ElMessageBox.confirm('你确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    const res = await api.SalesPartnerPermissionUserDelete({
                        id: row.id
                    })
                    if (res.data.code == 200) {
                        ElMessage.success('删除成功')
                        onSearch()
                    } else {
                        ElMessage.error('删除失败' + res.data.msg)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    ElMessage.info('已取消删除')
                })
        }

        const resetPassword = (row) => {
            resetPasswordVisible.value = true
            resetPasswordForm.id = row.id
            resetPasswordForm.password = ''
            resetPasswordFormRef.value?.clearValidate()
        }

        const updatePassword = async (formEl) => {
            if (!formEl) return
            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    try {
                        const res = await api.SalesPartnerPermissionUserPassword({
                            ...toRaw(resetPasswordForm),
                            password: md5(resetPasswordForm.password)
                        })
                        if (res.data.code == 200) {
                            ElMessage.success('成功')
                            resetPasswordVisible.value = false
                            onSearch()
                        } else {
                            ElMessage.error(res.data.msg)
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        onMounted(() => {
            getSalesPartnerList()
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util,
            dayjs,
            addUserVisible,
            addForm,
            addRules,
            partnerList,
            addFormRef,
            updateUser,
            edit,
            isEdit,
            deleteUser,
            resetPasswordVisible,
            resetPasswordForm,
            resetPasswordRules,
            resetPasswordFormRef,
            updatePassword,
            resetPassword
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
        padding-left: 16px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
